// extracted by mini-css-extract-plugin
export default {"subJankIssueFlameGraph":"SubJankIssueFlameGraphModal__subJankIssueFlameGraph__Gn4CB"};